<template>
  <div id="user-edit-tab-info">

    <!-- Avatar Row -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="flex items-start flex-col sm:flex-row">
          <vs-avatar :src="data.pictureUrl" size="80px" class="mr-4" />
          <div>
            <p class="text-lg font-medium mb-2 mt-4 sm:mt-0">{{ data.name }}</p>
            <vs-button class="mr-4 mb-4" @click="resendInvite">Reenviar convite</vs-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full">
        <vs-input class="w-full mt-4" label="Celular" v-mask="'(##) #####-####'" v-model="data_local.phone" v-validate="'required'" name="phone" />
        <span class="text-danger text-sm"  v-show="errors.has('phone')">{{ errors.first('phone') }}</span>
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="updateUser" :disabled="!validateForm">Atualizar dados</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Resetar</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      data_local: JSON.parse(JSON.stringify(this.data)),
      statusOptions: [
        { label: 'Active',  value: 'active' },
        { label: 'Blocked',  value: 'blocked' },
        { label: 'Deactivated',  value: 'deactivated' }
      ],
      roleOptions: [
        { label: 'Admin',  value: 'admin' },
        { label: 'User',  value: 'user' },
        { label: 'Staff',  value: 'staff' }
      ]
    }
  },
  computed: {
    status_local: {
      get () {
        return { label: this.capitalize(this.data_local.status),  value: this.data_local.status  }
      },
      set (obj) {
        this.data_local.status = obj.value
      }
    },
    role_local: {
      get () {
        return { label: this.capitalize(this.data_local.role),  value: this.data_local.role  }
      },
      set (obj) {
        this.data_local.role = obj.value
      }
    },
    validateForm () { return !this.errors.any() }
  },
  methods: {
    apiErrorMsg (msg) {
      if (msg === 'phone') { return 'Celular deve ser informado' }
      if (msg === 'users.phone') { return 'Celular já esta cadastrado' }
    },
    async resendInvite () {
      try {
        this.$vs.loading()
        await this.$http.post(
          `/api/v1/admin/company/reinvite/users/${this.data_local.id}`,
          {},
          { headers: { Authorization: localStorage.getItem('accessToken') } }
        )
        this.$vs.notify({
          title: 'Convite enviado',
          text: 'mensagem enviada com sucesso',
          iconPack: 'feather',
          color: 'success'
        })
      } catch (error) {
        this.$vs.notify({
          title: 'Convite não enviado',
          text: 'Erro ao mandar mensagem',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      } finally {
        this.$vs.loading.close()
      }
    },
    capitalize (str) { return str.slice(0, 1).toUpperCase() + str.slice(1, str.length) },
    async updateUser () {
      if (!this.validateForm) return
      try {
        console.log(this.data_local)
        this.$vs.loading()
        await this.$http.put(
          `/api/v1/admin/company/users/${this.data_local.id}`,
          this.data_local,
          { headers: { Authorization: localStorage.getItem('accessToken') } }
        )
        this.$vs.notify({
          title: 'Usuário atualizado',
          text: 'Atualização feita com sucesso',
          iconPack: 'feather',
          color: 'success'
        })
      } catch (error) {
        this.$vs.notify({
          title: 'Erro na Atualização',
          text: this.apiErrorMsg(error.response.data.errors[0].path),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      } finally {
        this.$vs.loading.close()
      }
    },
    reset_data () {
      this.data_local = JSON.parse(JSON.stringify(this.data))
    }
  }
}
</script>

<style>
.selfieP {
  margin-left: 5px;
  margin-top: 15px;
}
</style>
